import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../../assets/images/no-image.png';

export function SignatureConfig({ obj, handleFont, getImage, handleUploadImage, handleRemoveImage }) {
  const { t } = useTranslation('common');
  const filePreview = (element) => {
    return element ? encodeURI(`https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${element}`) : '';
  };

  const getImageSrc = () => {
    return obj?.digitalSignPath.includes('base64') ? getImage(obj?.digitalSignPath) : filePreview(obj?.digitalSignPath);
  };
  return (
    <div className="p-3">
      <div className="custom-tabs">
        <Tabs defaultActiveKey="type" id="uncontrolled-tab-example">
          <Tab eventKey="type" title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.SIGNATURE_CONFIG.TYPE')}>
            <div className="d-flex flex-wrap">
              {obj?.fontStyles?.map((element, index) => {
                return (
                  <div className="sign-container" key={element}>
                    <button
                      type="button"
                      className={obj?.fontFamily === element?.font ? 'active' : ''}
                      onClick={() => handleFont(element?.font, index)}
                      style={{ fontFamily: element?.font }}
                    >
                      {obj?.placeholder}
                    </button>
                  </div>
                );
              })}
            </div>
          </Tab>
          <Tab eventKey="upload" title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.SIGNATURE_CONFIG.UPLOAD')}>
            <div className="text-center p-3">
              <div className="image-upload-container">
                <figure>
                  <img className="img-thumb" src={getImageSrc() || noImage} alt="" />
                </figure>
                <div className="btn-container">
                  <button type="button" onClick={() => handleUploadImage('Signature')} className="btn">
                    <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.SIGNATURE_CONFIG.UPLOAD_IMAGE')}</span>
                    <i className="icon-upload mr-2" />
                  </button>
                  {obj?.digitalSignPath !== '' && (
                    <button type="button" onClick={() => handleRemoveImage('Signature')} className="btn">
                      <span className="sr-only">{t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.SIGNATURE_CONFIG.DELETE_IMAGE')}</span>
                      <i className="icon-delete mr-2" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default SignatureConfig;
